import { Field, FieldProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@mui/material';
import { PoolSelect, PoolTextArea, PoolTextField, PoolTypography, SelectOption } from '@synergy/components';
import { getCurrencySymbol } from '@synergy/utils';

import { bestLocaleSelector } from '../../../../../../common/selectors/locale-selectors';
import { useAppSelector } from '../../../../../../store/use-appstate-selector';

export const CustomerDetailConditionsDlh = () => {
    const supportedCurrencies = useAppSelector(state => state.settings.supportedCurrencies);
    const locale = useAppSelector(bestLocaleSelector);

    const currencyOptions: SelectOption[] = supportedCurrencies.map(currency => ({
        value: currency,
        displayValue: currency,
    }));

    const getCurrencySuffix = (currency: string) => ' ' + getCurrencySymbol(currency, locale);

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
                <PoolTypography
                    sx={{ mb: 1 }}
                    styleType="sectionTitleNew"
                    id="app.contactsAndOrganizations.conditions.dlh"
                />
            </Grid>
            <Grid item={true} xs={3}>
                <Field name="discount">
                    {({ field, meta }: FieldProps<number>) => (
                        <PoolTextField
                            isNumeric={true}
                            minDecimalScale={2}
                            label={<FormattedMessage id="app.contactsAndOrganizations.conditions.dlh.discount" />}
                            fullWidth={true}
                            suffix={' %'}
                            error={!!meta.touched && !!meta.error}
                            helperText={meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : null}
                            {...field}
                        />
                    )}
                </Field>
            </Grid>
            <Grid item={true} xs={3}>
                <Field name="currency">
                    {({ field, form }: FieldProps<string>) => (
                        <PoolSelect
                            label={<FormattedMessage id="app.label.currency" />}
                            fullWidth={true}
                            value={field.value}
                            onValueChange={value => form.setFieldValue(field.name, value)}
                            options={currencyOptions}
                            noSorting={true}
                            disallowDefaultValue={true}
                        />
                    )}
                </Field>
            </Grid>
            <Grid item={true} xs={3}>
                <Field name="base">
                    {({ field, form, meta }: FieldProps<string>) => (
                        <PoolTextField
                            isNumeric={true}
                            minDecimalScale={2}
                            label={<FormattedMessage id="app.contactsAndOrganizations.conditions.dlh.base" />}
                            fullWidth={true}
                            suffix={getCurrencySuffix(form.values.currency)}
                            error={!!meta.touched && !!meta.error}
                            helperText={meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : null}
                            {...field}
                        />
                    )}
                </Field>
            </Grid>
            <Grid item={true} xs={3}>
                <Field name="bulk">
                    {({ field, meta }: FieldProps<string>) => (
                        <PoolTextField
                            isNumeric={true}
                            minDecimalScale={2}
                            label={<FormattedMessage id="app.contactsAndOrganizations.conditions.dlh.bulk" />}
                            fullWidth={true}
                            error={!!meta.touched && !!meta.error}
                            helperText={meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : null}
                            {...field}
                        />
                    )}
                </Field>
            </Grid>
            <Grid item={true} xs={12}>
                <Field name="internalNote">
                    {({ field }: FieldProps<string>) => (
                        <PoolTextArea
                            label={<FormattedMessage id="app.contactsAndOrganizations.detail.internalNotes" />}
                            rowsMax="50"
                            rows="5"
                            {...field}
                        />
                    )}
                </Field>
            </Grid>
        </Grid>
    );
};
